
/* Name: App.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
*
* Description: 
*/


import { PageLayout } from './components/PageLayout';
import { TokenInterceptorProvider } from './components/tokenInterceptor';
import React from "react";

//import './App.css';

function App() {
 
  return (
    <>
    <>
      <TokenInterceptorProvider />
      <PageLayout title="VR SM4">
          {/* <center>
              <ProtectedContent />
          </center> */}
      </PageLayout>
    </>
    </>
  );
}

export default App;
